import React, { FC, useEffect, useState, useContext } from 'react';
import { useParams } from "react-router";
import { 
    Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, 
    Table, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, 
    Typography, withStyles 
} from "@material-ui/core";
import { useTask,TasksDispatchContext } from '../stateManagement/context';
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import DialogContentText from "@material-ui/core/DialogContentText";
import { IDocument } from "../types/types";
import { getDocuments } from '../stateManagement/data';
// import CreateDocumentDialog from './create_document_dialog';
import { get, post, upload } from "../fetchers/fetchers";
import { API_URL } from "../env";

interface IRouteParams {
    id: string
}



const AddingButton = withStyles(theme => ({
    root: {
        margin: "auto",
        backgroundColor: "rgba(0,103,114,0.2)",
        color: "rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);

const DocumentTable: FC = () => {
    let dispatch = useContext(TasksDispatchContext)
    const params = useParams<IRouteParams>()
    const [write_access, setWriteAccess] = useState<boolean>(false);
    const [documents, setDocuments] = useState<IDocument[]>([]);
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState<IDocument | null>(null);
    const [areYouSure, setAreYouSure] = useState<boolean>(false);
    const [newDocument, setNewDocument] = useState<IDocument>({});

    const tasks = useTask()

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])


    useEffect(() => {
        setDocuments(tasks.documents)  // Assuming consequenceCategories are present in tasks
    },[ tasks.documents])

   
    const handleEdit = (document: IDocument) => {
        // make a copy of the document
        let d = { ...document };

        if (d.date) {
            const dateObj = new Date(d.date);
            d.date = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
        }
        setNewDocument(d);

        setCreateDialogOpen(true);
    };

    type keys = "name" | "reference" | "author" | "filename" | "description" | "date" | "comment";

    const renderField = (label: string, key: keys, type: string) => {
        return <div>
            <div style={{
                width:"100%",
                margin:"auto",
            }}>
                <TextField
                    fullWidth
                    label={label}

                    value={newDocument[key]}
                    onChange={(event) => {
                            let v = (event.target.value as any);
                            let c = {...newDocument};
                            c[key] = v
                            setNewDocument(c)
                    }
                    }
                    type={type}
                />
            </div>
        </div>
    }

    const addDocument = async (document: IDocument) => {
        let d = { ...document };
        delete d.id;
        delete d.assessment_project_id;

        d.document_type_id = 1;
        



        // check if d has uuid
        if (!d.uuid) {
            d.uuid = -1;
        }

        // remove all null values
        Object.keys(d).forEach((key: string) => {
            if (d[key as keyof IDocument] == null) {
                delete d[key as keyof IDocument];
            }
        });

        await post<IDocument>(API_URL + "documents/" + params.id.toString(), d);
        await getDocuments(params.id, dispatch);
    };


    const handleClose = () => {
        setCreateDialogOpen(false)
        setNewDocument({})
    }

    const createDocument = () => {
        addDocument(newDocument).then(() => setCreateDialogOpen(false))
        setNewDocument({})
    }

    const prepareDelete = (document: IDocument) => {
        setSelectedDocument(document);
        setAreYouSure(true);
    };

    const handleAreaYouSure = () => {
        setAreYouSure(false);
        setSelectedDocument({});
    };
    const handleDelete = () => {

        let d = { ...selectedDocument };
        d.is_active = false;

        // convert string to date
        if (d.date) {
            const dateObj = new Date(d.date);
            d.date = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
        }

        addDocument(d).then(() => setAreYouSure(false));
    }

    const renderAreYouSure = () => {
        return (
            <Dialog open={areYouSure} onClose={handleAreaYouSure} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Remove reference </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to delete the reference: <b>{selectedDocument?.name}</b>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAreaYouSure} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const create_dialog = () => {
        return (
            <Dialog open={createDialogOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Create or update document</DialogTitle>
                <DialogContent>


                    {renderField("Citation", "name", "string")}
                    {renderField("Title", "reference", "string")}
                    {renderField("Author", "author", "string")}
                    {renderField("Reference", "filename", "string")}
                    {renderField("Description", "description", "string")}
                    {renderField("Comment", "comment", "string")}
                    {renderField("Date", "date", "date")}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={createDocument} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const convertDate = (date?: string) => {
        if (date) {
            return  new Date(date).toLocaleDateString('en-GB')
        }
        return "";
    }


   
    return (
        <TableContainer >
            {renderAreYouSure()}
            {createDialogOpen && create_dialog()}
            { write_access && <Tooltip title="Add Document" placement={'bottom-end'}>
                <AddingButton style={{ backgroundColor: "rgb(239,88,43)", color: "#FFFFFF" }}  onClick={() => setCreateDialogOpen(true)} >
                    <AddIcon fontSize="small" />
                </AddingButton>
            </Tooltip> }

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Document Name</TableCell>
                        <TableCell align="center">Author</TableCell>
                        <TableCell align="center">Reference</TableCell>
                        <TableCell align="center">Filename</TableCell>
                        <TableCell align="center">Description</TableCell>
                        <TableCell align="center">Comment</TableCell>
                        <TableCell align="center">Date</TableCell>
                        { write_access &&  <TableCell align="center">Actions</TableCell> }
                    </TableRow>
                </TableHead>

                {documents.map((document) => {
                    return (
                        <TableRow key={document.id}>
                            <TableCell>{document.name}</TableCell>
                            <TableCell>{document.author}</TableCell>
                            <TableCell>{document.reference}</TableCell>
                            <TableCell>{document.filename}</TableCell>
                            <TableCell>{document.description}</TableCell>
                            <TableCell>{document.comment}</TableCell>
                            <TableCell>{convertDate(document.date)}</TableCell>
                            { write_access && <TableCell>
                                <IconButton onClick={() => handleEdit(document)}  component="span" style={{
                                    color:"rgb(239,88,43)",
                                }}>
                                    <EditIcon />
                                </IconButton>
                                <IconButton onClick={() => prepareDelete(document)} component="span" style={{
                                    color:"rgb(239,88,43)",
                                }}>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell> }
                        </TableRow>
                    )
                })}
            </Table>

        </TableContainer>
    );
}

export default DocumentTable;
